import { CanDeactivateFn } from '@angular/router';
import EditArticleItemComponent from '../pages/edit-article-item/edit-article-item.component';
import { askFn } from '@softline/ui-core';

export const askUnsavedChangesGuard: CanDeactivateFn<EditArticleItemComponent> = async (
  component
): Promise<boolean> => {
  const ask = askFn();

  if (component.hasChanges()) {
    const result = await ask({
      title: 'Ungespeicherte Änderungen',
      question:
        'Wenn Sie die Seite verlassen gehen die ungespeicherten Änderungen verloren. Wollen Sie fortfahren?',
    });

    return result === 'YES';
  }

  return true;
};
